<template>
  <div>
    <b-row class="match-height">
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <Traffic-Anydesk />
      </b-col>
      <b-col
        lg="7"
        md="12"
        sm="12"
      >
        <Traffic-Phase />
      </b-col>
      <b-col
        lg="5"
        md="12"
        sm="12"
      >
        <b-row>
          <b-col>
            <Traffic-Map2 />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <Traffic-Pie />
          </b-col>
        </b-row>
      </b-col>
      <b-col
        lg="12"
        md="12"
        sm="12"
      >
        <Traffic-Bar />
      </b-col>
      <!-- <b-col
        lg="5"
        md="12"
        sm="12"
      >
        <Traffic-Current />
      </b-col> -->
      <b-col lg="12">
        <Traffic-Table />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import TrafficAnydesk from '@/views/traffic/detail/TrafficAnydesk.vue'
import TrafficPhase from '@/views/traffic/detail/TrafficPhase.vue'
import TrafficMap2 from '@/views/traffic/detail/TrafficMap2.vue'
import TrafficPie from '@/views/traffic/detail/TrafficPie.vue'
import TrafficTable from '@/views/traffic/detail/TrafficTable.vue'
import TrafficBar from '@/views/traffic/detail/TrafficBar.vue'
// import TrafficCurrent from '@/views/traffic/detail/TrafficCurrent.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    TrafficAnydesk,
    TrafficPhase,
    TrafficPie,
    TrafficMap2,
    TrafficTable,
    // TrafficCurrent,
    TrafficBar,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
